export const SET_SUBSCRIPTIONS_DATA = 'SET_SUBSCRIPTIONS_DATA';